import { last, find, startsWith, groupBy } from 'libraries/lodash'
import { parseJson } from 'helpers/transforms'
import dayjs from 'dayjs'
import { SEARCH_DATE_FORMAT, TIME_FORMAT } from 'constants/locale'
import { ALL_FLAVOURS } from 'constants/flavours'
import { DEFAULT_AOL_ORDER } from 'constants/aol/aol'
import { SHARED_EMAIL_PREFS } from 'constants/feature-flags'

export const toUser = function (data) {
  const {
    mail: email,
    firstName,
    lastName,
    roles = [],
    accessRoles = [],
    uri = '',
    appPin = null,
    analyticsId,
    areaOfLaw,
    primaryAolSetByUser = false,
    enableSmartFeatures = false
  } = parseJson(data)
  const userId = last(uri.split(':'))
  return {
    email,
    firstName,
    lastName,
    name: `${firstName} ${lastName}`,
    passwordStatus: 'Password never changed',
    pin: appPin,
    roles,
    uri,
    userId,
    analyticsId,
    areaOfLaw,
    primaryAolSetByUser,
    accessRoles,
    smartFeatures: enableSmartFeatures
  }
}

export const toUserAuth = function (data) {
  const { isExternalAuth } = parseJson(data)
  return { isExternalAuth }
}

export const toTracking = function (data) {
  const { tracking } = parseJson(data)
  return { trackingId: tracking }
}

export const toSearchHistory = function (data) {
  const { histories } = parseJson(data)
  const toFlavour = str =>
    (str && find(ALL_FLAVOURS, f => startsWith(f, str))) || null
  return {
    history: histories.map(e => ({
      date: dayjs(e.timestamp).format(SEARCH_DATE_FORMAT),
      flavour: toFlavour(e.searchType.split('-')[1] || null),
      term: e.searchTerm,
      time: dayjs(e.timestamp).format(TIME_FORMAT),
      type: e.searchType.split('-')[0]
    }))
  }
}

export const DayMap = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5
}

export const toEmailPreferences = function (json) {
  const data = parseJson(json)

  if (SHARED_EMAIL_PREFS) {
    const { mon, tue, wed, thu, fri, receiveNoNews, areaOfLawPrefs } = data
    const days = { mon, tue, wed, thu, fri }
    const caEmailDays = Object.entries(days).reduce((acc, [key, value]) => {
      if (value) {
        return [
          ...acc,
          DayMap[key]
        ]
      }

      return acc
    }, [])

    return { caEmailDays, receiveNoNews, areaOfLawPrefs }
  }

  const groupedPreferences = groupBy(
    data.map(({ areaOfLaw, enabled, ...days }) => ({
      areaOfLaw,
      caEmails: enabled,
      caEmailDays: Object.entries(days).reduce((acc, [key, value]) => {
        if (value) {
          return [
            ...acc,
            DayMap[key]
          ]
        }

        return acc
      }, [])
    })),
    'areaOfLaw'
  )

  return Object.keys(groupedPreferences).reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: groupedPreferences[curr][0]
    }
  }, {})
}

export const toAolOrderPreferences = function (json) {
  return parseJson(json).areasOfLaw || DEFAULT_AOL_ORDER
}

export const toPrimaryAol = function (json) {
  return parseJson(json).areaOfLaw || 'corporate'
}

export const toPractisingAol = function (json) {
  return parseJson(json).areaOfLaw || ''
}
